import { Link } from 'react-router-dom';
import { Brand } from './Brand.tsx';
import { ThemeToggle } from './ThemeToggle.tsx';

type Props = {
  /** Optional inline meta at the right edge of the header (e.g. countdown) */
  right?: React.ReactNode;
};

export function SiteHeader({ right }: Props) {
  return (
    <header className="relative z-10 flex items-center justify-between border-b border-border px-8 py-5">
      <Link to="/" className="flex items-center gap-4 group">
        <Brand height={26} />
        <span className="hidden h-6 w-px bg-border-strong md:block" />
        <span className="hidden text-[11px] tracking-[0.22em] uppercase text-text-faint md:inline">
          Okan Üniversitesi <span className="text-text-muted">·</span> Bekir Okan Kültür Merkezi
        </span>
      </Link>
      <div className="flex items-center gap-4">
        <span className="hidden text-[11px] uppercase tracking-[0.22em] text-text-faint sm:inline">
          Sezon 2026
        </span>
        {right}
        <ThemeToggle />
      </div>
    </header>
  );
}
